module.exports = __webpack_public_path__ + "img/zhaoshang_woyaodaili@2x.87052f09.png";